<template>
  <section>
    <div class="loading style-2">
        <v-progress-circular color="primary" size="100" indeterminate class="loading-wheel"/>
    </div>
  </section>
</template>

<script>
export default {

}
</script>

<style scoped>
.loading {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1000;
    background-color: transparent;
}


.loading-wheel {
    margin-top: -40px;
    margin-left: -40px;
    
    position: absolute;
    top: 50%;
    left: 50%;
    
    border-width: 30px;
    border-radius: 50%;
}
</style>